"use strict";

exports.__esModule = true;
exports["default"] = void 0;
//@ts-check

/**
 * @param {string} key
 * @returns {string}
 */
var getStyleTagId = function getStyleTagId(key) {
  return "react-style-" + key;
};
var _default = exports["default"] = getStyleTagId;
module.exports = exports.default;